var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 748,
    height: 198,
    viewBox: "0 0 748 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M747.58 197.98H438.27C383.73 197.98 339.36 153.61 339.36 99.0702C339.36 55.5602 303.96 20.1602 260.45 20.1602H-6V0.160156H260.45C314.99 0.160156 359.36 44.5302 359.36 99.0702C359.36 142.58 394.76 177.98 438.27 177.98H747.58V197.98Z",
    fill: "url(#paint0_linear_485_189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.26 19.6602C239.507 19.6602 243.76 15.4069 243.76 10.1602C243.76 4.91345 239.507 0.660156 234.26 0.660156C229.013 0.660156 224.76 4.91345 224.76 10.1602C224.76 15.4069 229.013 19.6602 234.26 19.6602Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.45 197.48C497.697 197.48 501.95 193.227 501.95 187.98C501.95 182.733 497.697 178.48 492.45 178.48C487.203 178.48 482.95 182.733 482.95 187.98C482.95 193.227 487.203 197.48 492.45 197.48Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_485_189",
    x1: -6,
    y1: 99.0702,
    x2: 747.58,
    y2: 99.0702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ECFAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BAEFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6CDCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30CFB0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLine);
export default __webpack_public_path__ + "static/media/left_line.2fe0275047b53ba1cd1ede73901074f4.svg";
export { ForwardRef as ReactComponent };